import _extends from "@babel/runtime/helpers/extends";
import { Box, Text } from '@wix/design-system';
import { ProductCardList } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { ECLIPSE_BG, ECLIPSE_SALE_BG_COLOR } from '../../utils';
import s from './ProductHat.scss';
const VARIANT_STYLES = {
  sale: {
    backgroundColor: ECLIPSE_SALE_BG_COLOR,
    className: s.saleText
  },
  recommended: {
    backgroundColor: ECLIPSE_BG,
    className: s.recommendedText
  },
  currentProduct: {
    backgroundColor: '#DFE5EB',
    className: s.currentProductText
  }
};
export const ProductHatUi = _ref => {
  let {
    text,
    variant,
    backgroundColor,
    ...tagProps
  } = _ref;
  const variantStyles = VARIANT_STYLES[variant];
  return /*#__PURE__*/React.createElement(ProductCardList.Default.Card.Tag, _extends({
    height: "30px",
    isVisible: true
  }, tagProps), /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    align: "center",
    verticalAlign: "middle",
    height: "100%",
    borderRadius: "4px",
    backgroundColor: backgroundColor ?? variantStyles.backgroundColor
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    align: "center",
    size: "small",
    className: variantStyles.className
  }, text)));
};
//# sourceMappingURL=ProductHatUi.js.map